import classNames from "classnames/bind";
import { useEffect, useState, useRef } from "react";
import { Close } from "../../../../components/Icons/Icons";
import styles from './ModalMoreDetail.module.css';
import empty from '../../../../assets/images/Emty.png'
import PropTypes from 'prop-types'
import axiosClient from "../../../../services/axiosClient";
import { useNavigate } from "react-router-dom";

const cx = classNames.bind(styles);


function ModalMoreInfo({ showModal, data }) {
    const [listCamera, setListCamera] = useState()
    const navigate = useNavigate()
    const boxRef = useRef()
    useEffect(() => {
        if (data.type === 'camera') {
            const getListCamera = async (code) => {
                const res = await axiosClient.get(`/cameraManagement/get-list-camera-by-group-code/?group_code=${code}`)
                setListCamera(res)
                return res;
            }
            getListCamera(data.data[0])
        }
    }, [data])

    const getShowModal = () => {
        showModal()
    }

    useEffect(() => {
        const handleClickOutSide = (e) => {
            if (e.target === boxRef.current) {
                showModal()
            }
        }
        document.body.addEventListener('click', handleClickOutSide)
        return () => {
            document.body.addEventListener('click', handleClickOutSide)
        }
        // eslint-disable-next-line
    }, [])
    const handleClickCheckCamera = (code) => {
        navigate(`/admin/camera_group/edit_group/${code}`)
    }
    return (
        <div className={cx('modal-container')} ref={boxRef}>
            <div className={cx('modal-content')}>
                <div className={cx('header')}>
                    {data.type === 'group' ? <h1>Danh sách nhóm camera</h1> : data.type === 'service' ? <h1>Danh sách dịch vụ</h1> : data.type === 'camera' ? <h1>Danh sách camera</h1> : ''}
                    <span className={cx('button-close')} onClick={getShowModal}><Close /></span>
                </div>
                <ul className={cx('body')}>
                    {data.type !== 'camera' ?
                        <>
                            {data.data.length > 0 ? data.data.map((item, index) => {
                                return (
                                    <li key={index} className={cx('item-content')}>
                                        <p className={cx('index')}>{index + 1}</p>
                                        <p className={cx('content')}>{data.type === 'group' ? item.GROUP_NAME : item.SERVICE_NAME}</p>
                                    </li>
                                )
                            }) :
                                <div className={cx('empty')}>
                                    <img src={empty} alt={'empty'} />
                                </div>}
                        </> :
                        <>
                            {listCamera?.length > 0 ? listCamera.map((item, index) => {
                                return (
                                    <li key={index} className={cx('item-content')} onClick={() => handleClickCheckCamera(data.data[0])}>
                                        <p className={cx('index')}>{index + 1}</p>
                                        <p className={cx('content')}>{item.NAME_CAM}</p>
                                    </li>
                                )
                            }) :
                                <div className={cx('empty')}>
                                    <img src={empty} alt={'empty'} />
                                </div>
                            }
                        </>
                    }
                </ul>
            </div>
        </div>
    )
}

ModalMoreInfo.propTypes = {
    showModal: PropTypes.func.isRequired
}

export default ModalMoreInfo;